/**
 * index.jsx - THE VERY FIRST FILE THAT RUNS
 * -----------------------------------------
 * The browser loads index.html, which loads this file. All it does is:
 *   1. Pull in the stylesheets
 *   2. Find the empty <div id="root"> in index.html
 *   3. Draw the whole React app inside it
 *   4. Start the background script that receives notifications
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { I18nProvider } from './hooks/useI18n';
import { registerServiceWorker } from './services/push';

// Order matters: variables first, then global styles, then components.
import './styles/variables.css';
import './styles/App.css';
import './styles/components.css';
// Scoped to `.landing` - the front page only. See the note at the top of it.
import './styles/landing.css';

/**
 * Register the background script early, so it is ready by the time somebody
 * turns notifications on.
 *
 * Registering is NOT the same as asking permission - nothing is requested here
 * and no prompt appears. Permission is only ever asked from a real click, on
 * the settings screen, because a browser ignores a request that did not come
 * from one and some of them treat an ignored request as a refusal, which
 * cannot be undone from the site afterwards.
 */
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* BrowserRouter gives the app page addresses like /marketplace */}
    <BrowserRouter>
      {/* I18nProvider is OUTSIDE AuthProvider on purpose: the language has to
          work for somebody who is not logged in, which is most of the front
          page and both signup paths - the screens an Italian family sees
          first. */}
      <I18nProvider>
        {/* AuthProvider remembers who is logged in, for every page */}
        <AuthProvider>
          <App />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>
);
